export enum CustomErrorCode {
    CUSTOM_LAW_FIELD_VALIDATION = 'CUSTOM_LAW_FIELD_VALIDATION',
}
